import type { LeadTimeDate } from './LeadTimeDatesProvider';

const emptyLeadTimeDate: LeadTimeDate = {
    cargoClosingDate: null,
    warehouseArrival: null,
    iltWorstCaseProperty: null,
    cancelDate: null,
    ccDateWeekNumber: null,
    whaDateWeekNumber: null,
};

export { emptyLeadTimeDate };
